import { render, staticRenderFns } from "./AbuseReported.vue?vue&type=template&id=7ce07d52&"
import script from "./AbuseReported.vue?vue&type=script&lang=js&"
export * from "./AbuseReported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports